import React from "react";
import getWeekOfMonth from "date-fns/getWeekOfMonth";
import Day from "./Day";
import DayContainer from "./DayContainer";



const Week = React.memo(({days, month, selectDate, type}) => {

    if (getWeekOfMonth(new Date(days[0]), {weekStartsOn: 1}) === 1) {
        return (
            <div className="week">
                {Array.from({length: 7 - days.length}).map((_, index) => <div key={index}></div>)}
                {days.map((day, index) => {

                    return (<DayContainer key={day} day={day} inDay={month[day]} selectDate={selectDate} type={type}/>)
                    }
                )}
            </div>
        )
    } else {
        return (
            <div className="week">
                {days.map((day, index) => {
                    return (<DayContainer key={day} day={day} inDay={month[day]} selectDate={selectDate} type={type}/>)
                    }
                )}
                {Array.from({length: 7 - days.length}).map((_, index) => <div key={index}></div>)}
            </div>
        )
    }

})


export default Week